import { loyaltyClient } from '../common/loyaltyClient';
import type {
  GetCustomerBalanceRequest,
  GetCustomerBalanceResponse,
  GetTransactionHistoryRequest,
  GetTransactionHistoryResponse,
  GetLoyaltyPolicyRequest,
  GetLoyaltyPolicyResponse,
} from './utils/types';

class LoyaltyAPIClient {
  public async getCustomerBalance({ customerId }: GetCustomerBalanceRequest): Promise<GetCustomerBalanceResponse> {
    return await loyaltyClient.get(`/loyalty/customers/${customerId}/balance`).then((res) => res.data);
  }

  public async getTransactionHistory({
    customerId,
    limit,
    lastEvaluatedKey,
  }: GetTransactionHistoryRequest): Promise<GetTransactionHistoryResponse> {
    return await loyaltyClient
      .get(`/loyalty/customers/${customerId}/transactions`, {
        params: { limit, lastEvaluatedKey },
      })
      .then((res) => res.data);
  }

  public async getLoyaltyPolicy({ currency }: GetLoyaltyPolicyRequest): Promise<GetLoyaltyPolicyResponse> {
    return await loyaltyClient.get('/loyalty/policy', { params: { currency } }).then((res) => res.data);
  }
}

export const loyaltyAPIClient = new LoyaltyAPIClient();
